export const Endpoints = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    routes: {
        get: {
            participant: '/participant',
            user: '/user',
            tent: '/tent',
        },
        post: {
            login: '/login',
            participant: '/participant',
            user: '/user',
            tent: '/tent',
            tents: '/tents',
            sendWelcome: '/send-welcome-mail',
        },
        update: {
            user: '/update-user',
            participant: '/participant',
            tent: '/tent',
        },
        delete: {
            user: '/user',
            participant: '/participant',
            tent: '/tent',
        },
        others: {
            archive: '/archive',
        },
    },
};
